import { render, staticRenderFns } from "./RetakeCourseSelection.vue?vue&type=template&id=40a94b20"
import script from "./RetakeCourseSelection.vue?vue&type=script&lang=js"
export * from "./RetakeCourseSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports